import modalSimple from './modal-simple'

export default {
    // π ----
    // :: INIT ---------------------------::
    // ____
    init() {
        const modalRoot = this
        const modal = $(`[data-modal-simple='lightbox-form']`)

        if (!modal.length) {
            return
        }

        const target = $(modal).find('[data-lightbox-form-target]')

        $('[data-open-lightbox-form]').click(event => {
            event.preventDefault()

            const formId = event.currentTarget.getAttribute('data-open-lightbox-form')

            if (!formId) {
                return
            }

            modalRoot.loadForm(target, formId)
            modalSimple.cards(modalSimple, modal)
        })
    },

    // π ----
    // :: LOAD FORM ---------------------------::
    // ____
    loadForm(target, formId) {
        $(target).empty()
        $(target).addClass('opacity-0')

        hbspt.forms.create({
            portalId: '21956497',
            formId: formId,
            region: 'na1',
            target: '#hubspotform-lightbox',
            onFormReady: () => {
                this.styleForm(target)
            },
        })
    },

    styleForm(target) {
        const iframe = $(target).find('iframe.hs-form-iframe')[0]

        if (iframe) {
            const style = document.createElement('style')
            style.textContent = 'html { margin-top: 0 !important; } body { margin-top: 0 !important; padding-top: 0 !important; } #wpadminbar { display: none !important; } * { font-family: Calibre,Helvetica Neue,sans-serif !important; } .hs-form-field label, .hs-form-field legend, .hs-field-desc, .legal-consent-container, .hs-richtext, .hs-richtext p { color: #ffffff !important; } .hs-form-required { color: #e21c3f !important; } .hs-form-field a, .legal-consent-container a, .hs-richtext a { color: #e21c3f !important; }'
            iframe.contentDocument.head.appendChild(style)
        }

        $(target).removeClass('opacity-0')
    },
}
